import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
// import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import AvailableTrainers from "./live-trials/AvailableTrainers";
import CloseSubmitBtn from "../common-components/custom-comps/CloseSubmitBtn";

const ResolutionForm = ({
  userInfoData,
  rowData,
  closeModal,
  from,
  callFunction,
}) => {
  const dispatch = useDispatch();

  const initialFormValues = {
    selectedOptions: [],
    otherOption: "",
    remarks: "",
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState({});

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormValues((prev) => {
        const newSelectedOptions = [...prev.selectedOptions];

        if (checked) {
          if (!newSelectedOptions.includes(name)) {
            newSelectedOptions.push(name);
          }
        } else {
          const index = newSelectedOptions.indexOf(name);
          if (index > -1) {
            newSelectedOptions.splice(index, 1);
          }
        }

        return {
          ...prev,
          selectedOptions: newSelectedOptions,
        };
      });
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const validateForm = (values) => {
    const errors = {};

    if (values.selectedOptions.length === 0) {
      errors.options = "Please select at least one resolution option!";
    }

    if (
      values.selectedOptions.includes("other") &&
      !values.otherOption.trim()
    ) {
      errors.otherOption = "Please specify the other option!";
    }

    return errors;
  };

  const handleSubmitForm = async (payload) => {
    // const payload = {
    //   type: from,
    //   uid: rowData?.uid || "",
    //   resolved_by: userInfoData?.user_id || userInfoData?.uid || "",
    // };
    const method = "POST";
    const endpoint = "/attandance/resolve-notification";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        callFunction();
        toast.success(result?.payload?.message || "Success!");
        closeModal();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
        // closeModal();
      }
    } catch (error) {
      console.error("Error making POST request:", error);
      // closeModal();
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const finalOptions = [...formValues.selectedOptions];
      if (
        formValues.selectedOptions.includes("other") &&
        formValues.otherOption.trim()
      ) {
        const otherIndex = finalOptions.indexOf("other");
        const formattedOtherOption = formValues.otherOption
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "_");
        finalOptions[otherIndex] = formattedOtherOption;
      }

      const userData = {
        type: from,
        uid: rowData?.uid || "",
        resolved_by: userInfoData?.user_id || userInfoData?.uid || "",
        resolution: finalOptions.join(", "),
        remarks: formValues.remarks || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `You want to resolve this member ${
          rowData?.name || rowData?.user_name || ""
        }'s query with options: ${finalOptions.join(", ")}?`,
        "No, Cancel",
        "Yes, Resolve"
      );
    }
  };

  // useEffect(() => {
  //   showConfirmAlert(
  //     handleSubmitForm,
  //     `You want to resolve this member ${
  //       rowData?.name || rowData?.user_name || ""
  //     }'s query ?`,
  //     "No, Cancel",
  //     "Yes, Resolve",
  //     false,
  //     closeModal
  //   );
  // }, []);

  return (
    <>
      <div className="createNewCTOModalContainer mod-width-50p">
        <AvailableTrainers
          userInfoData={userInfoData}
          rowData={rowData}
          closeModal={closeModal}
          isOnlyMemberInfo={true}
        />

        <form className="formContainer mt-0" onSubmit={onSubmit}>
          {/* <CommonHeadingNBtns
            title="Resolve Query"
            onClose={closeModal}
            btnTxt="submit"
            onClick={onSubmit}
          /> */}

          <div className="formInputsGrid twoGridSystem">
            <div className="formInputBox checkbox-wrapper span2">
              <label
                htmlFor="options"
                className="formInputLabel"
                style={{ marginBottom: "10px" }}
              >
                choose options from below which you have resolved{" "}
                <span className="required">*</span>
              </label>

              <div className={`flex-box`}>
                <label className="checkboxLabel">
                  <input
                    type="checkbox"
                    name="pt_trial"
                    checked={formValues.selectedOptions.includes("pt_trial")}
                    onChange={onChangeInput}
                  />
                  PT Trial
                </label>

                <label className="checkboxLabel">
                  <input
                    type="checkbox"
                    name="bca"
                    checked={formValues.selectedOptions.includes("bca")}
                    onChange={onChangeInput}
                  />
                  BCA
                </label>

                <label className="checkboxLabel">
                  <input
                    type="checkbox"
                    name="renewal"
                    checked={formValues.selectedOptions.includes("renewal")}
                    onChange={onChangeInput}
                  />
                  Renewal
                </label>

                <label className="checkboxLabel">
                  <input
                    type="checkbox"
                    name="trainer_map"
                    checked={formValues.selectedOptions.includes("trainer_map")}
                    onChange={onChangeInput}
                  />
                  Trainer Map
                </label>

                <label className="checkboxLabel">
                  <input
                    type="checkbox"
                    name="other"
                    checked={formValues.selectedOptions.includes("other")}
                    onChange={onChangeInput}
                  />
                  Other
                </label>
              </div>

              {formErrors.options && (
                <span className="error-label">{formErrors.options}</span>
              )}
            </div>

            {formValues.selectedOptions.includes("other") && (
              <div className="formInputBox span2">
                <label htmlFor="otherOption" className="formInputLabel">
                  other queries <span className="required">*</span>
                </label>

                <input
                  type="text"
                  placeholder="Enter other option"
                  className={`formInput ${
                    formErrors?.otherOption ? "formError" : ""
                  }`}
                  name="otherOption"
                  value={formValues.otherOption}
                  onChange={onChangeInput}
                />

                {formErrors.otherOption && (
                  <span className="error-label">{formErrors.otherOption}</span>
                )}
              </div>
            )}

            <div className="formInputBox span2">
              <label htmlFor="remarks" className="formInputLabel">
                remarks
              </label>

              <textarea
                placeholder="Enter remarks"
                className={`formInput ${formErrors.remarks ? "formError" : ""}`}
                style={{ minHeight: "150px" }}
                name="remarks"
                value={formValues.remarks}
                onChange={onChangeInput}
              />
            </div>
          </div>

          <CloseSubmitBtn
            closeLabel="Cancel"
            submitLabel="submit"
            onClose={closeModal}
            onSubmit={onSubmit}
            isLoading={false}
          />
        </form>
      </div>
    </>
  );
};

export default ResolutionForm;
